import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import KR from "./Access/KR/KR";
import JB from "./Access/JB/JB";
import PB from "./Access/PB/PB";
import SBC from "./Access/SBC/SBC";
import CN from "./Access/CN/CN";
import UserManagement from "./UserManagement/UserManagement";
import BrandsManagement from "./BrandManagement/BrandsManagement";
import DeactivatedUserPage from "./DeactivatedUserPage";
import Page404 from "./Page404";
import { jwtDecode } from "jwt-decode";
import { getValidToken, isTokenExpired, clearAuthData } from "../utils/auth";

import Dashboard from "./Dashboard";
import RJ from "./Access/RJ/RJ";
import LAC from "./Access/LAC/LAC";
import KT from "./Access/KT/KT";

function ProtectedRoute() {
  const token = getValidToken();

  // If no valid token, clear any stale data and redirect
  if (!token) {
    clearAuthData();
    return <Navigate to="/" />;
  }

  const decodedToken = jwtDecode(token);
  const userRole = decodedToken ? decodedToken.role : null;
  const userAccess = decodedToken ? decodedToken.access : null;
  const userId = decodedToken ? decodedToken.idlogin : null;

  // Admins have access to all brand routes (mirrors Dashboard admin override)
  const effectiveAccess =
    userRole === "admin"
      ? ["KR", "SBC", "JB", "PB", "RJ", "LAC", "CN", "KT"]
      : userAccess || [];

  if (userRole && userRole === "deactivated") {
    return <DeactivatedUserPage />;
  }

  return (
    <Routes>
      <Route
        path="homepage"
        element={token ? <Dashboard /> : <Navigate to="/" />}
      />
      {effectiveAccess.includes("KR") && (
        <Route path="kr" element={token && <KR />} />
      )}
      {effectiveAccess.includes("SBC") && (
        <Route path="sbc" element={token && <SBC />} />
      )}
      {effectiveAccess.includes("JB") && (
        <Route path="jb" element={token && <JB />} />
      )}
      {effectiveAccess.includes("PB") && (
        <Route path="pb" element={token && <PB />} />
      )}
      {effectiveAccess.includes("RJ") && (
        <Route path="rj" element={token && <RJ />} />
      )}
      {effectiveAccess.includes("LAC") && (
        <Route path="lac" element={token && <LAC />} />
      )}
      {effectiveAccess.includes("CN") && (
        <Route path="cn" element={token && <CN />} />
      )}
      {effectiveAccess.includes("KT") && (
        <Route path="kt" element={token && <KT />} />
      )}
      {userRole && userRole === "admin" && (
        <Route
          path="userManagement"
          element={
            userRole === "admin" && <UserManagement currentUserId={userId} />
          }
        />
      )}
      {userRole && userRole === "admin" && (
        <Route
          path="brandManagement"
          element={
            userRole === "admin" && <BrandsManagement currentUserId={userId} />
          }
        />
      )}
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}

export default ProtectedRoute;
